module.exports = __webpack_public_path__ + "static/media/about-vpassport-es.91d3f74b.mp4";